//Reference: EN0119

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';
export class TaskStatus extends Mappeable {

    idTypeStatePk: number;
    txtState: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtState: this.txtState,
            mrkActive: this.mrkActive
        }
    }


}